import { __assign } from "tslib";
import { ChangeLogSelect } from './Changelog';
import { FindOneLogWithLogEntryInclude, LogEntryInclude } from './LogEntry';
import { UserSelect } from './User';
export var LogExportInclude = {
    category: { select: { name: true } },
    location: { select: { name: true } },
    product: { select: { name: true } },
    owner: { select: { email: true } },
};
export var LogIncludeLean = {
    category: {
        select: {
            name: true,
        },
    },
    organizationEmissions: {
        where: { deletedAt: null, outOfScope: false },
        select: {
            id: true,
            createdAt: true,
            updatedAt: true,
            logEntryId: true,
            scopeId: true,
            subcategoryId: true,
            logId: true,
            categoryId: true,
            emissionFactorId: true,
            locationId: true,
            organizationId: true,
            businessUnitId: true,
            value: true,
            scope: true,
            factor: true,
            logEntryTags: true,
            tags: true,
            conversionFactors: true,
        },
    },
    logEntries: {
        where: { deleted: false },
        orderBy: {
            createdAt: 'asc',
        },
        include: {
            inputs: {
                where: { deletedAt: null },
                select: {
                    id: true,
                    createdAt: true,
                    updatedAt: true,
                    deleted: true,
                    unitId: true,
                    organizationId: true,
                    version: true,
                    logEntryId: true,
                    value: true,
                    inputKey: true,
                    unit: true,
                },
            },
            customer: {
                select: {
                    name: true,
                },
            },
            subcategory: {
                select: {
                    name: true,
                },
            },
            activityDataSource: {
                select: {
                    name: true,
                },
            },
            calculationMethod: {
                select: {
                    name: true,
                },
            },
            supplier: {
                select: {
                    name: true,
                },
            },
            tags: {
                include: {
                    tag: true,
                },
            },
            territory: {
                select: {
                    name: true,
                },
            },
        },
    },
    location: { include: { businessUnit: true } },
    owner: {
        select: {
            email: true,
        },
    },
    product: {
        include: { businessUnit: true },
    },
};
export var LogInclude = {
    organizationEmissions: {
        where: { deletedAt: null, outOfScope: false },
        include: {
            scope: true,
            factor: true,
        },
    },
    location: { include: { businessUnit: true } },
    product: {
        include: { businessUnit: true },
    },
    owner: true,
    organization: true,
    apiTransaction: {
        include: {
            integration: true,
        },
    },
    category: {
        include: {
            scope: true,
            image: true,
            subcategories: true,
        },
    },
    logEntries: {
        where: { deleted: false },
        orderBy: {
            createdAt: 'asc',
        },
        include: LogEntryInclude(),
    },
    changeLogs: {
        where: { deleted: false },
        select: __assign(__assign({}, ChangeLogSelect), { user: {
                select: UserSelect,
            } }),
    },
    files: true,
};
export var FindOneLogInclude = function (emissionFactor) {
    if (emissionFactor === void 0) { emissionFactor = true; }
    return ({
        apiTransaction: {
            include: {
                integration: true,
            },
        },
        category: {
            include: {
                scope: true,
                image: true,
                subcategories: true,
            },
        },
        organizationEmissions: {
            where: { deletedAt: null },
            include: {
                scope: true,
                factor: true,
            },
        },
        logEntries: {
            where: { deleted: false },
            orderBy: {
                createdAt: 'asc',
            },
            include: FindOneLogWithLogEntryInclude(emissionFactor),
        },
        changeLogs: {
            where: { deleted: false },
            select: __assign(__assign({}, ChangeLogSelect), { user: {
                    select: UserSelect,
                } }),
        },
        files: true,
        location: { include: { businessUnit: true } },
        product: { include: { businessUnit: true } },
        owner: true,
        organization: true,
    });
};
//# sourceMappingURL=Log.js.map